export type EmailType =
  | 'CONTACT'
  | 'SUPPORT'
  | 'PRIVACY'
  | 'BUSINESS'
  | 'PRESS'
  | 'HELP'


export const EMAILS: Record<EmailType, string> = {
  CONTACT: 'thanh@pixie.education',
  SUPPORT:' carol@pixie.education',
  PRIVACY: 'support@pixie.education',
  BUSINESS: 'business@pixieworld.app',
  PRESS: 'press@pixieworld.app',
  HELP: 'help@pixieworld.app',
}

export const getEmail = (key: EmailType): string => EMAILS[key]